import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';

import { useStores } from 'util/mobx/stores';
import SideMenuIconButton from 'components/SideMenuIconButton';
import MoreMenuMaterialSearchButton from 'components/MoreMenuMaterialSearchButton';

const CreateNewMaterialRightMenu = observer(() => {
  const { t } = useTranslation('guideSingleMaterial');
  const { domainStore, flyoutStore, postStore } = useStores();

  const handleSwitchDomainClick = () => {
    domainStore.setShowSwitchDomainFlyout(true);
  };

  const handleCreateMaterial = () => {
    flyoutStore.setIsCreateSingleMaterialFlyoutOpen(true);
  };

  const onCommentsFlyoutOpen = async () => {
    await postStore.loadDepartmentPosts(domainStore.currentDepartment.id);
    postStore.setIsChatFlyoutOpen(true);
  };

  return (
    <>
      {!domainStore.isMobile && (
        <SideMenuIconButton handleClick={handleCreateMaterial} label={t('button.createMaterial')} iconPath="icon_f-add_16.svg" />
      )}
      <SideMenuIconButton handleClick={onCommentsFlyoutOpen} label={t('button.allComments')} iconPath="icon_icon_f-comment_16_blue.svg" />
      <SideMenuIconButton handleClick={handleSwitchDomainClick} label={t('button.switchDepartment')} iconPath="icon_pin-edit_16.svg" />
      <MoreMenuMaterialSearchButton />
    </>
  );
});

export default CreateNewMaterialRightMenu;
